import DateTimeRange from 'admin/components/atoms/DateTimeRange';
import { DateRangeSelector, DEFAULT_OPTIONS } from 'admin/components/molecules/DateRangeSelector';
import Button from 'admin/components/shared/Button';
import React, { useState } from 'react';
import CSSModules from 'react-css-modules';
import styled from 'styled-components';
import SelectedPrivateMoneyDisplay from '../../../organisms/SelectedPrivateMoneyDisplay';
import styles from './styles.scss';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DateRangeRowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const DateRangeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FilterForm = ({
  dateRange,
  onDateRangeChange,
  onDateRangeSelectorChange,
  onClickFilter,
  csvButton,
}) => {
  const [selectedPeriod, setSelectedPeriod] = useState('today');

  const handleDateRangeSelectorChange = (period, range) => {
    setSelectedPeriod(period);
    onDateRangeSelectorChange({ from: range.from, to: range.to });
  };

  const handleDateTimeRangeChange = (newDateRange) => {
    onDateRangeChange(newDateRange);
  };

  return (
    <Wrapper>
      <SelectedPrivateMoneyDisplay wrapperStyles={{ marginBottom: 0 }} />
      <DateRangeRowWrapper>
        <DateRangeWrapper>
          <DateRangeSelector
            value={selectedPeriod}
            onChange={handleDateRangeSelectorChange}
            options={DEFAULT_OPTIONS}
          />
          <DateTimeRange
            dateRange={dateRange}
            setDateRange={handleDateTimeRangeChange}
            validTypeTo="invalidFromBeforeDay"
            wrapperStyles={{ marginBottom: 0 }}
            dateTimeProps={{
              fromProps: { showIcon: true },
              toProps: { showIcon: true },
            }}
          />
          <Button onClick={onClickFilter}>計算</Button>
        </DateRangeWrapper>
        {csvButton}
      </DateRangeRowWrapper>
    </Wrapper>
  );
};

export default CSSModules(FilterForm, styles);
